module.exports = __webpack_public_path__ + "static/media/ms.be22c04d.jpeg";